import { Route } from 'config/routes';
import { DealType } from './entities';
import { dealTypeInvertedDict } from 'consts/dictionaries';

export const buildSearchPathWithMinRooms = (
  routeName: Route.Search | Route.SearchCommercial,
  minRooms: number,
  dealType: DealType,
  term: string
) => {
  const dealTypeFromDict = dealTypeInvertedDict[dealType];

  let path: string;
  switch (routeName) {
    case Route.Search:
      path = `/for-${dealTypeFromDict}/${term}/${minRooms}-bd`;
      break;
    case Route.SearchCommercial:
      path = `/commercial/for-${dealTypeFromDict}/${term}/${minRooms}-bd`;
      break;
  }

  return encodeURI(path);
};
